import React from 'react';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';

interface Props {
    settings: SearchProps,
}

export const GroupListLabels = (props: Props) => {
    const { settings } = props;

    return (
        <div className='sort-table-row'>
            <div className='sort-table-row-cell'>
                <SortButton label={settings?.groupIDLabel} name='group_id' />
               
            </div>
            <div className='sort-table-row-cell'>
                <SortButton label={settings?.groupNameLabel} name='name' />
            </div>
        </div>
    );

};